/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { VersionId } from "../../commons/types/VersionId";
import { CommitId } from "../../commons/types/CommitId";
import { SortField } from "../../commons/types/SortField";
import { SortDirection } from "../../commons/types/SortDirection";
import { Filter } from "../../commons/types/Filter";
import { FilterField } from "../../commons/types/FilterField";
import { SearchValue } from "../../commons/types/SearchValue";
import { SearchField } from "../../commons/types/SearchField";
import { RecordId } from "../../commons/types/RecordId";
import { EventId } from "../../commons/types/EventId";
export const ViewConfig = core.serialization.object({
    versionId: VersionId.optional(),
    commitId: CommitId.optional(),
    sinceVersionId: VersionId.optional(),
    sinceCommitId: CommitId.optional(),
    sortField: SortField.optional(),
    sortDirection: SortDirection.optional(),
    filter: Filter.optional(),
    filterField: FilterField.optional(),
    searchValue: SearchValue.optional(),
    searchField: SearchField.optional(),
    ids: core.serialization.list(RecordId).optional(),
    pageSize: core.serialization.number().optional(),
    pageNumber: core.serialization.number().optional(),
    includeCounts: core.serialization.boolean().optional(),
    includeLength: core.serialization.boolean().optional(),
    includeLinks: core.serialization.boolean().optional(),
    includeMessages: core.serialization.boolean().optional(),
    for: EventId.optional(),
    q: core.serialization.string().optional(),
});
